import React from 'react'
import PropTypes from 'prop-types'
import InputAdornment from '@material-ui/core/InputAdornment'
import Email from '@material-ui/icons/Email'
import LockOpen from '@material-ui/icons/LockOpen'
import CustomInput from 'components/CustomInput/CustomInput.jsx'
import Card from 'components/Card/Card.jsx'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardFooter from 'components/Card/CardFooter.jsx'
import CircularLoadingButton from 'views/Components/CircularLoadingButton'
import validate, { constraints } from 'services/formValidator'
import RequestPwdForm from 'views/Forms/RequestPwdForm'
import translation from '../../translation/translate'
import { withStyles } from '@material-ui/core'
import style from 'assets/css/style.jsx';
const styles = require(`../../assets/css/style.jsx`).default;

const client = process.env.REACT_APP_CLIENT

const login_constraints = {
  username: [constraints.isRequired, constraints.isEmail],
  password: [constraints.isRequired]
}

class LoginForm extends React.Component {
  state = {
    data: {
      username: '',
      password: ''
    },
    errors: {}
  }

  onChange =  e => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    })
  }

  onSubmit = e => {
    e.preventDefault()
    const errors = validate(this.state.data, login_constraints)
    this.setState({ errors })
    if (Object.keys(errors).length === 0) {
      this.props
        .login(this.state.data)
    }
  }

  render() {
    const {loading, classes } = this.props
    const { errors } = this.state
    return (
      <form onSubmit={this.onSubmit} className={classes.form}>
        <Card login className={classes[this.state.cardAnimaton]}>
          <CardHeader className={classes.loginHeader} style={styles.loginHeader}>
            <h4 style={styles.cardTitle}>{translation[client].login_title}</h4>
          </CardHeader>
          <CardBody>
            <CustomInput
              id='username'
              error={!!errors.username}
              helpText={errors.username}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                placeholder: 'Adresse e-mail *',
                name: 'username',
                onChange: this.onChange,
                startAdornment: (
                  <InputAdornment position='start'  className={classes.inputAdornment}>
                    <Email className={classes.inputAdornmentIcon} />
                  </InputAdornment>
                )
              }}
            />
            <CustomInput
              id='password'
              error={!!errors.password}
              helpText={errors.password}
              formControlProps={{
                fullWidth: true,
                className: classes.customFormControlClasses
              }}
              inputProps={{
                placeholder: 'Mot de passe *',
                name: 'password',
                type: 'password',
                onChange: this.onChange,
                startAdornment: (
                  <InputAdornment position='start' className={classes.inputAdornment}>
                    <LockOpen
                      className={classes.inputAdornmentIcon}
                    />
                  </InputAdornment>
                )
              }}
            />
          </CardBody>
          <CardFooter className={classes.justifyContentCenter}>
            {/*<RequestPwdForm />*/}
            <CircularLoadingButton
              btnContent='Connectez-vous'
              loading={loading}
              className={classes.root}
              buttonProps={{
                style:styles.btnLogin,
                type:'submit',
              }}
            />
          </CardFooter>
          <RequestPwdForm classes={classes} />
        </Card>
      </form>
    )
  }
}

LoginForm.propTypes = {
  login: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

export default withStyles(style) (LoginForm)



// WEBPACK FOOTER //
// ./src/views/Forms/LoginForm.jsx